// usePreloadUserEngagements.js
import { useEffect } from 'react';

// Context
import { useUser } from 'context/UserContext';

import { subscribeToEngagements } from 'services/engagements/EngagementReadService';

/**
 * Custom hook to load engagements for a specific user.
 */
const usePreloadUserEngagements = () => {

  // User Context
  const { user, setUserEngagements } = useUser();

  useEffect(() => {

    // Exit early if no selected user
    if (!user || !user.key) {
      setUserEngagements([]);
      return;
    }

    const load = () => {
      const handleUpdate = (engagements) => {
        setUserEngagements(engagements);
      };

      const params = [
        { field: "userKey", operator: "==", value: user.key }
      ];

      const sortFields = [
        { field: "dateCreated", order: "desc" }
      ];

      const unsubscribe = subscribeToEngagements({ params, sortFields }, handleUpdate);

      return unsubscribe;
    };

    const unsubscribeEngagements = load();

    return () => {
      if (unsubscribeEngagements) {
        unsubscribeEngagements();
      }
    };
  }, [user, setUserEngagements]);

};

export default usePreloadUserEngagements;
